<template>
  <div>
    <center>
      <v-img height="100%" :src="imageHeadHRM"></v-img>
      <v-container fluid>
      <v-row dense>
        <v-col>
          <v-card>
              <v-img
                @click="Home()"
                :lazy-src="imageUrlBack"
                max-height="30"
                max-width="100"
                :src="imageUrlBack"
              ></v-img>
          </v-card>
           <p></p>
            <v-alert
              class="text-left"
              dense
              outlined
              type="info"
            >
              โปรดใส่ข้อมูลชุดนี้ตามความเป็นจริง
            </v-alert>
          <v-card>
            <v-card
            class="mx-auto my-2 text-left"
            elevation="12"
            v-for="(items, index) in vaccineItem" :key="index"
          >
            <v-card-title>
              <v-row>
                <v-col cols="8">
                <b>รายการรับวัคซีน เข็มที่ {{items.vaccineDoses}}</b>
                </v-col>
                  <v-col cols="2">
                <v-img
                :lazy-src="vaccineAdd"
                max-height="30"
                max-width="30"
                :src="vaccineAdd"
              ></v-img>
                <v-img
                :lazy-src="vaccineAddComplete"
                max-height="80"
                max-width="80"
                :src="vaccineAddComplete"
              ></v-img>
                </v-col>
              </v-row>
            </v-card-title>
            <v-card-text>
              <div class="text--primary" @click="getDataById(items)">
                <v-row>
                <v-col cols="6">
                ชื่อวัคซีน  <br> <b><h5>{{items.vaccineName}}</h5></b>
                </v-col>
                 <v-col cols="6">
                ประเภทการได้รับ <br> <b><h5>  {{items.vaccineCategory}} </h5></b>
                 </v-col>
                 <v-col cols="6">
                วันที่รับวัคซีน <br> <b><h5> {{items.vaccineDay}}/{{items.vaccineMonth}}/{{items.vaccineYear}}  </h5></b>
                 </v-col>
                 <v-col cols="6">
                ช่วงเวลา <br> <b><h5>{{items.vaccineTime}} </h5></b> <br>
                 </v-col>
                 </v-row>
              </div>
            </v-card-text>

          </v-card>
            <v-row :show="!dataReady" >
              <v-col cols="12" sm="6" md="4">
              <v-btn color="success" dark block x-large @click="dialog = true"
                >กดเพิ่มประวัติรับวัคซีน<v-icon right dark>
                  mdi-plus-circle
                </v-icon></v-btn
              >
              </v-col>
            </v-row>
            <v-dialog v-model="dialog" fullscreen persistent>

              <v-card>
                 <v-toolbar
                color="indigo"
                dark
              >
                <v-toolbar-title>ประวัติรับวัคซีน</v-toolbar-title>

                <v-spacer></v-spacer>

                <v-btn icon @click="dialog = false">
                  <v-icon >mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
              <br>
                <v-card-text>
                    <v-row no-gutters>
                      <v-col cols="12" sm="12" md="12">
                        <v-select
                          v-model="formAdd.vaccineName"
                          :items="vaccineType"
                          @change="checkVaccineType(formAdd.vaccineName,formAdd.vaccineDoses)"
                          class="pa-2"
                          outlined
                          label="วัคซีน"
                        ></v-select>
                      </v-col>
                      <v-col cols="12" sm="12" md="12">
                        <v-select
                          v-model="formAdd.vaccineCategory"
                          :items="categoryName"
                          outlined
                          label="ประเภทได้รับ"
                        ></v-select>
                      </v-col>
                      <v-col cols="6" sm="6" md="6">
                        <v-select
                          v-model="formAdd.day"
                          :items="dayName"
                          outlined
                          label="วัน"
                        ></v-select>
                      </v-col>
                      <v-col cols="6" sm="6" md="6">
                        <v-select
                          v-model="formAdd.month"
                          :items="monthNameTH"
                          outlined
                          label="เดือน"
                        ></v-select>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-select
                          v-model="formAdd.year"
                          :items="yearsNumber"
                          outlined
                          label="ปี"
                        ></v-select>
                      </v-col>
                       <v-col cols="6" sm="6" md="6">
                        <v-select
                          v-model="formAdd.hour"
                          :items="hourNumber"
                          outlined
                          label="ชั่วโมง"
                        ></v-select>
                      </v-col>
                      <v-col cols="6" sm="6" md="6">
                        <v-select
                          v-model="formAdd.minute"
                          :items="minuteNumber"
                          outlined
                          label="นาที"
                        ></v-select>
                      </v-col>
                        <v-col cols="12" sm="6" md="6">
                        <v-select
                          v-model="formAdd.vaccineDoses"
                          :items="vaccineDosesName"
                           @change="checkVaccineType(formAdd.vaccineName,formAdd.vaccineDoses)"
                          outlined
                          label="ฉีดเข็มที่"
                        ></v-select>
                      </v-col>
                    </v-row>
                    <v-card-actions>
                         <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="dialog = false">
                    Close
                  </v-btn>
                  <v-btn color="blue darken-1" text @click="approve()" v-if="isCheckDoses">
                    Save
                  </v-btn>
                </v-card-actions>
                </v-card-text>
              </v-card>
            </v-dialog>
            <v-dialog v-model="dialogEdit" fullscreen persistent>

                <v-toolbar
                color="indigo"
                dark
              >
                <v-toolbar-title>ประวัติรับวัคซีน {{formUpdate.vaccineDoses}}</v-toolbar-title>

                <v-spacer></v-spacer>

                <v-btn icon @click="dialogEdit = false">
                  <v-icon >mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
              <v-card>
                <v-card-text>
                     <v-row no-gutters>
                       <v-col cols="12" sm="12" md="12">
                        <v-select
                          v-model="formUpdate.vaccineName"
                          :items="vaccineType"
                          @change="checkVaccineType(formUpdate.vaccineName,formUpdate.vaccineDoses)"
                          outlined
                          label="วัคซีน"
                          class="ma-2"
                        ></v-select>
                      </v-col>
                       <v-col cols="12" sm="12" md="12">
                        <v-select
                          v-model="formUpdate.vaccineCategory"
                          :items="categoryName"
                          outlined
                          label="วัคซีน"
                          class="ma-2"
                        ></v-select>
                      </v-col>
                      <v-col cols="6" sm="6" md="6">
                        <v-select
                          v-model="formUpdate.vaccineDay"
                          :items="dayName"
                          outlined
                          label="วัน"
                          class="ma-2"
                        ></v-select>
                      </v-col>
                      <v-col cols="6" sm="6" md="6">
                        <v-select
                          v-model="formUpdate.vaccineMonth"
                          :items="monthNameTH"
                          outlined
                          label="เดือน"
                          class="ma-2"
                        ></v-select>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-select
                          v-model="formUpdate.vaccineYear"
                          :items="yearsNumber"
                          outlined
                          label="ปี"
                          class="ma-2"
                        ></v-select>
                      </v-col>
                       <v-col cols="6" sm="6" md="6">
                        <v-select
                          v-model="formUpdate.hour"
                          :items="hourNumber"
                          outlined
                          label="ชั่วโมง"
                          class="ma-2"
                        ></v-select>
                      </v-col>
                      <v-col cols="6" sm="6" md="6">
                        <v-select
                          v-model="formUpdate.minute"
                          :items="minuteNumber"
                          outlined
                          label="นาที"
                          class="ma-2"
                        ></v-select>
                      </v-col>
                      <v-col cols="12" sm="12" md="12">
                        <v-select
                          v-model="formUpdate.vaccineDoses"
                          :items="vaccineDosesName"
                          @change="checkVaccineType(formUpdate.vaccineName,formUpdate.vaccineDoses)"
                          outlined
                          label="ฉีดเข็มที่"
                          class="ma-2"
                        ></v-select>
                      </v-col>
                    </v-row>
                    <v-card-actions>
                   <v-btn color="red darken-1" text @click="dialogEdit = false, deleteData(formUpdate)" v-if="isCheckDoses" >
                    delete
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="dialogEdit = false">
                    Close
                  </v-btn>
                  <v-btn color="blue darken-1" text @click="dialogEdit = false, edit(formUpdate)" v-if="isCheckDoses">
                    Save
                  </v-btn>
                </v-card-actions>
                </v-card-text>
              </v-card>
            </v-dialog>
          </v-card>
        </v-col>
      </v-row>
      </v-container>
    </center>
  </div>
</template>
<script>
import dayName from '../../assets/master/Date/day.json'
import monthNameTH from '../../assets/master/Date/monthNameTH.json'
import yearsNumber from '../../assets/master/Date/yearsNumber.json'
import hourNumber from '../../assets/master/Date/Hour.json'
import minuteNumber from '../../assets/master/Date/Minute.json'
// import vaccine from '../../assets/master/vaccine/vaccineName.json'
import vaccineDosesName from '../../assets/master/vaccine/vaccineDosesName.json'
import categoryName from '../../assets/master/vaccine/categoryName.json'
import axios from 'axios'
import moment from 'moment'
// import VuetifyLogo from '../logo'
export default {
  components: {
    // VuetifyLogo
  },
  name: 'VaccinHistory',
  beforeCreate () {
    // this.$liff.init({ liffId: this.$liff_info }, function (data) {})
  },
  data () {
    return {
      profile: [],
      imageUrlBack: '',
      imageHeadHRM: '',
      vaccineAdd: '',
      vaccineAddComplete: '',
      vaccineItem: [],
      vaccineType: [],
      dialog: false,
      dialogEdit: false,
      formAdd: {
        vaccineDoses: 2,
        vaccineName: 'ซิโนฟาร์ม',
        vaccineYear: '',
        vaccineMonth: '',
        vaccineDay: '',
        vaccineTime: '',
        year: '',
        month: '',
        day: '',
        hour: 8,
        minute: 30,
        vaccineCategory: 'บริษัทจัดหา'
      },
      formUpdate: {
        vaccineDoses: 2,
        vaccineName: '',
        vaccineYear: '',
        vaccineMonth: '',
        vaccineDay: '',
        vaccineTime: '',
        hour: '',
        minute: '',
        vaccineCategory: ''
      },
      // vaccineCategory: 'บริษัทจัดหา',
      // vaccineName: 'ซิโนฟาร์ม',
      // vaccineDoses: 2,

      // hour: 8,
      // minute: 30,
      dayName: dayName,
      monthNameTH: monthNameTH,
      yearsNumber: yearsNumber,
      hourNumber: hourNumber,
      minuteNumber: minuteNumber,
      // vaccine: vaccine,
      vaccineDosesName: vaccineDosesName,
      categoryName: categoryName,
      isCheckDoses: true
    }
  },
  // eslint-disable-next-line space-before-function-paren
  async mounted() {
    this.imageUrlBack = require('@/assets/Icon/Back.jpg')
    this.imageHeadHRM = require('@/assets/Icon/HRM.jpg')
    this.vaccineAdd = require('@/assets/Icon/vaccineAdd.png')
    this.vaccineAddComplete = require('@/assets/Icon/วัคซีนเข็มที่8.png')

    let date = new Date()
    this.formAdd.year = moment().format('YYYY')
    this.formAdd.day = date.getDate()
    this.formAdd.month = this.getMonthTh()

    // if (JSON.parse(localStorage.getItem('liff_info'))) {
    //   await this.Home()
    // } else {
    await this.getDataVaccineType()
    await this.getDataVaccine()
    // }
  },
  methods: {
    Home () {
      this.$router.push('/Liff/Home')
    },
    async getDataVaccine () {
      this.dataReady = false
      this.vaccineItem = []

      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/vaccine/get?empCode=' +
            JSON.parse(localStorage.getItem('liff_info')).empCode
        )
        .then(async (response) => {
          // const vc = response.data.vaccineTime.split(':')
          // response.data.vaccineItem.vaccineTime = vc[0] + ':' + vc[1]

          this.vaccineItem = response.data
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
          this.vaccineItem = []
          this.dataReady = true
        })
    },
    async getDataById (ds) {
      this.dialogEdit = true
      this.formUpdate = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/vaccine/getID?vaccineId=" + ds.vaccineId
        )
        .then(async (response) => {
          // console.log(response.data)
          const vc = response.data.vaccineTime.split(':')
          // console.log(vc)
          this.formUpdate = response.data
          this.formUpdate.vaccineMonth = this.getMonthINTToTH(this.formUpdate.vaccineMonth)
          this.formUpdate.hour = Number(vc[0])
          this.formUpdate.minute = Number(vc[1])
          if (this.formUpdate.masVaccineType === 'covid' && this.formUpdate.vaccineDoses === 1) {
            this.isCheckDoses = false
          } else {
            this.isCheckDoses = true
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log('error function addDataGlobal : ', error)
        })
    },
    async edit (ds) {
      // console.log(ds)

      let dt = {
        vaccineName: this.formUpdate.vaccineName,
        vaccineCategory: this.formUpdate.vaccineCategory,
        vaccineYear: this.formUpdate.vaccineYear,
        vaccineMonth: this.getMonthThToINT(this.formUpdate.vaccineMonth),
        vaccineDay: this.formUpdate.vaccineDay,
        vaccineDoses: this.formUpdate.vaccineDoses,
        vaccineTime: this.formUpdate.hour + ':' + this.formUpdate.minute
      }
      // console.log(ds)
      await axios
        .post(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/vaccine/edit/" + ds.vaccineId,
          dt
        )
        .then(async (response) => {
          // console.log(response)
          await this.getDataVaccine()
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log('error function addDataGlobal : ', error)
        })
    },
    async deleteData (item) {
      // console.log(item)
      let dt = {
        LAST_USER: JSON.parse(localStorage.getItem('liff_info')).userName
      }
      // console.log(dt)
      await axios
        .post(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/vaccine/delete/" + item.vaccineId,
          dt
        )
        .then(async (response) => {
          // console.log(response)
          await this.getDataVaccine()
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log('error function deleteData : ', error)
        })
    },
    async approve () {
      // console.log(this.profile)
      // console.log(this.minute)
      let ds = {
        empCode: JSON.parse(localStorage.getItem('liff_info')).empCode,
        vaccineName: this.formAdd.vaccineName,
        vaccineCategory: this.vaccineCategory,
        vaccineYear: this.formAdd.year,
        vaccineMonth: this.getMonthThToINT(this.formAdd.month),
        vaccineDay: this.formAdd.day,
        vaccineDoses: this.formAdd.vaccineDoses,
        vaccineTime: this.formAdd.hour + ':' + this.formAdd.minute
      }
      // console.log(ds)

      await axios
        .post(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/vaccine/add", ds
        )
        .then(async (response) => {
          this.dialog = false
          // console.log(response)
          this.getDataVaccine()
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log('error function addDataGlobal : ', error)
        })
    },
    async getDataVaccineType () {
      // Clear Data ทุกครั้ง
      this.vaccineType = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/mas_vaccine/" + "get",
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.value = d.masVaccineName
            s.text = d.masVaccineName
            this.vaccineType.push(s)
          }
          console.log('getDataitems : ', this.vaccineType)
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })
    },
    async checkVaccineType (covid, vaccineDoses) {
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/mas_vaccine/" + "get?masVaccineName=" + covid,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          // console.log(response.data[0].masVaccineType)
          // console.log(vaccineDoses)

          if (response.data[0].masVaccineType === 'covid' && vaccineDoses === 1) {
            this.isCheckDoses = false
          } else {
            this.isCheckDoses = true
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })
    }
  }
}
</script>
<style scoped>
.table-header {
  background-color: black;
}
</style>



// WEBPACK FOOTER //
// src/components/Liff/VaccinHistory.vue